import {useMutation} from '@tanstack/react-query';
import {AxiosError, AxiosResponse} from 'axios';
import axiosInstance from '../../../axiosConfig';
import {IApiDataResponse} from '../../../dto/API.dto';
import {
  ISharePayload,
  IShareResponse,
  ISharedMessageType,
} from '../../../dto/MessageSharing.dto';
import {AxiosErrorToast} from '../../general/ReusableFunctions';

const shareMessage = (
  companyId: number,
  messageType: ISharedMessageType,
  requestId: number,
  data: ISharePayload,
) => {
  return axiosInstance
    .post(
      `/v1/company/${companyId}/message/${messageType}/${requestId}/share`,
      data,
    )
    .then(
      (
        response: AxiosResponse<
          IApiDataResponse<IShareResponse> | IShareResponse
        >,
      ) => {
        if ('data' in response.data) {
          return response.data.data;
        }

        return response.data;
      },
    )
    .catch((error: AxiosError) => {
      AxiosErrorToast(error, 'Error sharing message');
      throw error;
    });
};

export const useRqShareMessage = (
  companyId: number,
  messageType: ISharedMessageType,
  requestId: number,
) => {
  return useMutation({
    mutationFn: (data: ISharePayload) =>
      shareMessage(companyId, messageType, requestId, data),
  });
};
